/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
    "libs/apm/softwaretelemetry",
    "utils/browser",
    "utils/uuid",
    "client/resourceinfo",
    "jquery",
    "underscore",
  ], function(
    apm,
    browser,
    UUID,
    ResInfo,
    $,
    _
  ) {

    /*
    *
    * Username is currently only available if setUserName is called. At the moment
    * _profileUpdated of the application takes care of this.
    *
    */

    apm.env.url = ResInfo.scriptLocation + "../../web.telemetry";

    var TraceEvent = function () {
    };

    TraceEvent.prototype = {

      send: function(e) {
        var now = new Date().getTime();

        var contextCreated = false;
        if (!e.context) {
          contextCreated = true;
          e.context = apm.CreateContext(null, Trace.sessionId);
          events.identity.none(e.context, Trace.userName);
          events.referer.none(e.context, browser.getURL(), browser.getScheme(), browser.getHostname(), browser.getPort(), browser.getPathname());
        }

        this.beforeEvent(e);

        e.id = e.id || this.id;
        e.level = e.level || this.level || apm.LEVEL_LOG;
        e.flag = e.flag || this.flag || apm.FLAG_NONE;
        e.parameters = e.parameters || [];

        if (this.module.Event) {
          this.module.Event.apply(this.module, [e.context, e.id, e.level, e.flag].concat(e.parameters));
        }

        return contextCreated ? e.context : null;
      },

      beforeEvent: function (e) {
        var callbackAction;

        if (Trace.surroundingContextTokenCallbacks.length > 0) {
          callbackAction = this.getCallbackAction(e);
          if (callbackAction) {
            this.attachSurroundingContextTokens(e.context, callbackAction);
          }
        }
      },

      getCallbackAction: function (e) {
        if (Trace.surroundingContextTokenCallbacks.length < 1) return;

        var callbackAction;
        if (this.name === "search") {
          if (e.parameters && e.parameters.length > 2 && /^true$/i.test(e.parameters[2])) {
            callbackAction = "nextPage";
          } else {
            callbackAction = "search";
          }
        } else if (this.name === "action") {
          if (e.parameters && e.parameters.length > 0 && /^facet selection changed$/i.test(e.parameters[0])) {
            callbackAction = "filter";
          } else if (e.parameters && e.parameters.length > 0 && /^suggest$/i.test(e.parameters[0])) {
            callbackAction = "suggest";
          }
        }

        return callbackAction;
      },

      attachSurroundingContextTokens: function (ownContext, callbackAction) {
        _.each(Trace.surroundingContextTokenCallbacks, function (callback) {
          var surroundingContextToken;
          try {
            surroundingContextToken = callback(callbackAction);
          } catch (ex) {
            if (typeof console !== "undefined" && console.warn) {
              console.warn("error calling context token callback: ", ex);
            }
          }
          if (surroundingContextToken) {
            apm.AttachContext(ownContext, surroundingContextToken);
          }
        });
      }

    };

    var EnterLeaveEvent = function (module, id, name, enterParameters, leaveParameters, level, flag) {
      this.module = module;
      this.id = id;
      this.level = level;
      this.flag = flag;
      this.name = name;

      this.module.RegisterEvent(this.id, name, enterParameters);
      this.module.RegisterEvent(this.id + 1000, name, leaveParameters);
    };

    _.extend(EnterLeaveEvent.prototype, TraceEvent.prototype, {

        enter: function(context) {
          var createdContext = this.send({
              context: context,
              flag: apm.FLAG_ENTER,
              parameters: Array.prototype.slice.call(arguments, 1)
          });

          return new LeaveEvent(createdContext || context, this.module, this.id + 1000, this.level, this.flag, !!createdContext);
        }

    });
    
    var LeaveEvent = function (context, module, id, level, flag, releaseContext, parent) {
      this.context = context;
      this.module = module;
      this.id = id;
      this.level = level;
      this.flag = flag;
      this.releaseContext = releaseContext;
      this.parent = parent;
    };

    _.extend(LeaveEvent.prototype, TraceEvent.prototype, {

        leave: function () {
          var parent = this.parent;
          while (parent && parent.parent) parent = parent.parent;
          this.leaveParameters = (parent && parent.leaveParameters) || Array.prototype.slice.call(arguments);

          if (this.left) return;
          this.left = true;

          this.send({
              id: this.id,
              context: this.context,
              flag: apm.FLAG_LEAVE,
              parameters: this.leaveParameters
          });

          if (this.releaseContext) { Trace.releaseContext(this.context); }
        },

        willLeave: function () {
          this.left = true;

          return new LeaveEvent(this.context, this.module, this.id, this.level, this.flag, this.releaseContext, this);
        }

    });

    var NoneEvent = function (module, id, name, parameters, level, flag) {
      this.module = module;
      this.id = id;
      this.level = level;
      this.flag = flag;

      this.module.RegisterEvent(this.id, name, parameters);
    };

    _.extend(NoneEvent.prototype, TraceEvent.prototype, {

        none: function(context) {
          var createdContext = this.send({
              id: this.id,
              context: context,
              flag: apm.FLAG_NONE,
              parameters: Array.prototype.slice.call(arguments, 1)
          });

          if (createdContext) Trace.releaseContext(createdContext);
        }

    });
    // Setting values for TELEMETRY_ID and TELEMETRY_TIER_ID
    function getPortNumber()  {
      var portNum;
      if (typeof window !== "undefined" && window.location && window.location.port === "") {
        switch (window.location.protocol) {
          case "https:":
            portNum = ":443";
            break;
          case "http:":
            portNum = ":80";
            break;
          default:
            portNum = "";
        } 
      }
      else {
        portNum = "";
      }
      return portNum;
    };
 
    var APP_TELEMETRY_ID = "DEFAULT",
        PORT_NUMBER = getPortNumber(),
        HOST_NAME = (typeof window !== "undefined") && window && window.location && window.location.host || '',
        APP_TELEMETRY_TIER_ID = "Client (" + HOST_NAME + PORT_NUMBER + ")";

    /* setup */
    apm.RegisterApplication("Mindbreeze", APP_TELEMETRY_ID, "Client", APP_TELEMETRY_TIER_ID);
    var mHttp = apm.RegisterModule("XMLHttpRequest");
    var mUI = apm.RegisterModule("UI");
    var mService = apm.RegisterModule("Service");
    var mUsercontext = apm.RegisterModule("UserContext");
    var mOutput = apm.RegisterModule("Output");
    apm.Flush(true);

    var events = {};

    events.identity = new NoneEvent(mUsercontext, 1, "identity", "username");
    events.referer = new NoneEvent(mUsercontext, 2, "referer", "referer;referer_scheme;referer_host;referer_port;referer_path");
    events.httpRequest = new EnterLeaveEvent(mHttp, 3, "send", "path;url", "status;status_description");
    events.uiRender = new EnterLeaveEvent(mUI, 4, "render", "type");
    events.uiAction = new EnterLeaveEvent(mUI, 5, "action", "name;sender");
    events.serviceCall = new EnterLeaveEvent(mService, 6, "call", "method");
    events.search = new EnterLeaveEvent(mService, 7, "search", "count;user_query_expr;next_page;previous_page", "result_count;total_count;empty_results");
    events.outputParse = new EnterLeaveEvent(mOutput, 8, "parse");
    events.outputMerge = new EnterLeaveEvent(mOutput, 9, "merge");

    var Trace = {

      surroundingContextTokenCallbacks: [],
      sessionId: $('meta[name="mes:user"]').attr("content") || UUID.generate(),
      emailAddress: $('meta[name="mes:emailaddress"]').attr("content"),

      getInfos: function () {
        return [{
            name: "email",
            hidden: true,
            value: Trace.emailAddress
          },{
            name: "username",
            value: Trace.userName
        }]
      },

      feedbackHTML5ScreenshotEnabled: function() {
        if ( apm && apm.env && apm.env.report && apm.env.report.enableHTML5Screenshot != null) {
            return apm.env.report.enableHTML5Screenshot;
        }
        return true;
      },

      enableHTML5Screenshot: function(v) {
        if (apm && apm.env && apm.env.report) {
          apm.env.report.enableHTML5Screenshot = v;
        }
        return this;
      },

      feedback: function (formid) {
        apm.ReportDialog(null, Trace.sessionId, UUID.generate(), null, null, {
            infos: Trace.getInfos()
          },
          {
            formid: formid
        });
      },

      events: events,

      releaseContext: function (context) {
        if (!context) return;
        apm.ReleaseContext(context);
      },

      adaptRequestHeaders: function (headers, context) {
        headers = headers || {};
        headers["x-apm-telemetry-context"] = apm.GetContext(context);

        return headers;
      },

      instrument: function (f, eventName, parameterCallback) {
        var ev = events[eventName];
        var proxy = function () {
          var parameters = parameterCallback && parameterCallback.apply(this, arguments);
          var leave = ev.enter.apply(ev, [null].concat(parameters)),
              returnValue,
              status = "OK",
              statusDescription = "";

          try {
            returnValue = f.apply(this, _.toArray(arguments).concat([leave]));
          } catch (ex) {
            status = "NOK";
            statusDescription = ex.message;
            throw ex;
          } finally {
            leave.leave(status, statusDescription);
          }

          return returnValue;
        }

        return proxy;
      },

      enabled: apm.env.active,

      setUserName: function (userName) {
        Trace.userName = userName;
      },

      addSurroundingContextTokenCallback: function (callback) {
        Trace.surroundingContextTokenCallbacks.push(callback);
      },

      removeSurroundingContextTokenCallback: function (callback) {
        Trace.surroundingContextTokenCallbacks = _.without(this.surroundingContextTokenCallbacks, callback);
      }

    };

    return Trace;
});
